import { render, staticRenderFns } from "./FiltroRecursos.vue?vue&type=template&id=f788c622&scoped=true&"
import script from "./FiltroRecursos.vue?vue&type=script&lang=js&"
export * from "./FiltroRecursos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f788c622",
  null
  
)

export default component.exports